import { render, staticRenderFns } from "./AssistantBottom.vue?vue&type=template&id=131f08da&scoped=true&"
import script from "./AssistantBottom.vue?vue&type=script&lang=js&"
export * from "./AssistantBottom.vue?vue&type=script&lang=js&"
import style0 from "./AssistantBottom.vue?vue&type=style&index=0&id=131f08da&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131f08da",
  null
  
)

export default component.exports